
import UnsaveGuardMixin from '@/components/UnsaveGuardMixin';
import { Component, Ref, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { v4 } from 'uuid';
import SelectImagesModal from './SelectImagesModal.vue';
import LookImagesModal from './LookImagesModal.vue';
import QualityDescriptionModal from '@/views/shop/components/QualityDescriptionModal.vue';
import CoverImagesModal from '@/views/shop/components/CoverImagesModal.vue';
import VideoUModal from '@/components/video/VideoModal.vue';
import LookVideoModal from './LookVideoModal.vue';
import SelectVideoModal from './SelectVideoModal.vue';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import albumSpuShopIds from '@/components/account/albumSpuShopIds.vue';

@Component({
  components: {
    draggable,
    SelectVideoModal,
    SelectImagesModal,
    LookImagesModal,
    QualityDescriptionModal,
    CoverImagesModal,
    VideoUModal,
    LookVideoModal,
    albumSpuShopIds,
  },
})
export default class extends UnsaveGuardMixin {
  visibleAll = false;

  defaultDate: any = {};

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  headerVideo: any = [];

  headerImg: any[] = [];

  sourceType = '';

  templateName = '';

  title = '';

  templateId: any = '';

  @Prop()
  kaId!: number;

  @Prop()
  kaName!: string;

  wordTitleArray: any = [
    { title: '环境', id: '', type: 'env' },
    { title: '产品服务', id: '', type: 'product_service' },
    { title: '其他', id: '', type: 'other' },
    { title: '店内环境', id: '', type: 'inner_env' },
  ];

  oldHeaderId = [];

  // 初始化并显示模板管理抽屉
  init(data?: any, type?: any, Pitem?: any) {
    console.log(data);
    this.sourceType = type;
    if (type === 'add') {
      this.title = '相册添加';
    } else {
      this.title = '相册编辑';
      this.templateId = Pitem.template_id;
      this.templateName = Pitem.template_name;
      this.shops = data.shops.join(',');
      console.log(this.shops, 'sss');
    }
    this.defaultDate = data;
    this.oldHeaderId = data.header.elements.map((item: any) => item.resource_id);
    if (data.header.elements.length > 0) {
      if (data.header.elements[0].category === 2) {
        this.headerVideo = data.header.elements[0];
        this.headerImg = data.header.elements.slice(1);
        this.headerImg = [...this.headerImg, ...new Array(5 - this.headerImg.length).fill(0)];
      } else {
        this.headerVideo = {};
        this.headerImg = data.header.elements;
      }
    }
    this.visibleAll = true;
    //  this.hasUnsavedChanges = true;

    this.wordTitleArray = this.wordTitleArray.map((item: any) => {
      const { title, type: t } = item;
      const d = {
        title,
        type: t,
        id: this.returnDefaultData(t, 'id'),
      };
      return d;
    });
    console.log(this.wordTitleArray);
    //  const applyList = response.list.map((item: IApply) => CApply.from(item));
  }

  draftCount(type: any) {
    console.log(type, this.formData, 'draftCount');
    const res = this.formData[type];
    if (res) {
      return res.add.length;
    } else {
      return 0;
    }
  }

  onClose() {
    this.visibleAll = false;
    this.hasUnsavedChanges = false;
    this.formData = {};
    this.headerImg = [];
    this.templateName = '';
    this.headerVideo = {};
    this.shops = '';
    this.hasUnsavedChanges = false;
    console.log(this.formData);
  }
  shops: any = '';
  deepArraysEqual(a: any[], b: any[]): boolean {
    const cleanedA = a.filter((item) => item != null);
    const cleanedB = b.filter((item) => item != null);
    return JSON.stringify(cleanedA) === JSON.stringify(cleanedB);
  }
  async submitForm() {
    const header: any = [...[this.headerVideo], ...this.headerImg];
    console.log(header);
    const data: any = Object.assign({}, this.formData, {
      template_name: this.templateName,
      shops: this.shops != '' ? this.shops.split(',') : [],
      ka_id: this.kaId,
      header: header.filter((item: any) => item?.resource_id != null).map((item: any) => item.resource_id),
    });
    if (this.deepArraysEqual(data.header, this.oldHeaderId)) {
      delete data.header;
    }
    console.log(data);

    if (this.templateId) {
      data.template_id = this.templateId;
      console.log(data);
      const res = await this.brandService.brandAlbumKaTemplateEdit(data);
      if (res) {
        this.$message.success('编辑成功');
        this.$emit('success');
        this.onClose();
        this.hasUnsavedChanges = false;
      }
    } else {
      const res = await this.brandService.brandAlbumKaTemplateCreate(data);
      if (res) {
        this.$message.success('添加成功');
        this.$emit('success');
        this.onClose();
        this.hasUnsavedChanges = false;
      }
    }
  }
  uuid = v4;

  @Ref('selectVideoModal')
  selectVideoModal!: SelectVideoModal;

  @Ref('selectImagesModal')
  selectImagesModal!: SelectImagesModal;

  @Ref('lookImagesModal')
  lookImagesModal!: LookImagesModal;

  @Ref('qualityDescriptionModal')
  qualityDescriptionModal!: QualityDescriptionModal;

  @Ref('coverImagesModal')
  coverImagesModal!: CoverImagesModal;

  @Ref('videoUModal')
  videoUModal!: VideoUModal;

  @Ref('lookVideoModal')
  lookVideoModal!: LookVideoModal;

  disabled = true;

  val = [
  ];

  formData: any = {
    // cover: {},
    // video: {},
    // env: [],
    // product_service: [],
    // other: [],
    // inner_env: [],
  };

  submit() {
    console.log(this.val);
  }

  upLoadImage(val: any) {
    this.headerImg = val;
  }

  upLoadVideo(val: any) {
    this.headerVideo = val[0];
  }

  returnDefaultData(type: any, enumeration: any) {
    // console.log(type, enumeration, Object.prototype.hasOwnProperty.call(this.defaultDate, type));
    if (Object.prototype.hasOwnProperty.call(this.defaultDate, type)) {
      const text = this.defaultDate[type][enumeration];
      // console.log(text);
      return text;
    } else {
      return '';
    }
  }

  playVideo(obj: any) {
    this.videoUModal.open(obj.path);
  }


  replace() {
    console.log('替换', this.uuid());
    this.coverImagesModal.init();
  }

  changeSubmit(type: any, val: any) {
    // this.val = val;
    console.log(type, val);
    console.log(this.defaultDate, 'defaultDate');
    if (!Object.prototype.hasOwnProperty.call(this.defaultDate, type)) {
      const element = {
        cover: val.add[0].url,
      };
      this.$set(this.defaultDate, type, element);
    }
    this.hasUnsavedChanges = true;
    this.$set(this.formData, type, val);
    // this.formData[type] = val;
  }

  changeShops(val: any) {
    this.shops = val;
  }

  uploadCover(val: any) {
    console.log('上传封面', val);
    const type = 'cover';
    const data = {
      add: val,
    };
    const element = {
      element: val[0],
    };
    // this.defaultDate[type] = element;
    this.$set(this.defaultDate, type, element);
    this.formData[type] = data;
    console.log(this.formData);
    console.log(this.defaultDate);
  }

  selectFunFile(type: string) {
    // this.selectVideoModal.init();
    // console.log(this.formData);
    if (type === 'video') {
      const id: any = this.returnDefaultData('video', 'id');
      console.log(id);
      this.selectVideoModal.init(id);
    } else {
      this.selectImagesModal.init();
    }
  }

  openImage(name: string, type: string, albumId?: any) {
    const val: {
      edit: any;
      delete: any;
      add: any;
    } = this.formData[type] || {
      edit: [],
      delete: [],
      add: [],
    };

    const data = {
      edit: Object.prototype.hasOwnProperty.call(val, 'edit') ? val.edit : [],
      delete: Object.prototype.hasOwnProperty.call(val, 'delete') ? val.delete : [],
      add: Object.prototype.hasOwnProperty.call(val, 'add') ? val.add : [],
    };
    console.log(';ddddd', albumId);
    this.lookImagesModal.init(name, type, data, albumId);
  }

  openVideo(name: string, type: string, albumId?: any) {
    const val: {
      edit: any;
      delete: any;
      add: any;
    } = this.formData[type] || {
      edit: [],
      delete: [],
      add: [],
    };

    const data = {
      edit: Object.prototype.hasOwnProperty.call(val, 'edit') ? val.edit : [],
      delete: Object.prototype.hasOwnProperty.call(val, 'delete') ? val.delete : [],
      add: Object.prototype.hasOwnProperty.call(val, 'add') ? val.add : [],
    };
    this.lookVideoModal.init(name, type, data, albumId);
  }

  description() {
    this.qualityDescriptionModal.init();
  }
}
